import { cn } from '@/lib/core/utils/cn';

interface StepIndicatorProps {
  current: number;
  total: number;
  palette?: 'light' | 'dark';
  className?: string;
}

export function StepIndicator({ current, total, palette = 'light', className }: StepIndicatorProps) {
  const isLight = palette === 'light';
  return (
    <div
      className={cn('flex items-center justify-center gap-2', className)}
      aria-label={`Step ${current} of ${total}`}
    >
      <span
        className={cn(
          'font-pp-neue-montreal text-[12px] leading-3.5 font-[350] tracking-[0.5px] whitespace-nowrap uppercase',
          isLight ? 'text-white' : 'text-jncquoi-neutral-1000'
        )}
      >
        {current} / {total}
      </span>
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          aria-hidden="true"
          className={cn(
            'h-px w-3.5',
            isLight
              ? i === current - 1
                ? 'bg-white'
                : 'bg-white/40'
              : i < current
                ? 'bg-jncquoi-neutral-1000'
                : 'bg-jncquoi-neutral-200'
          )}
        />
      ))}
    </div>
  );
}
